export { default as TabContent } from './TabContent';
export { default as TabItem } from './TabItem';
export { default as Tabs } from './Tabs';



// WEBPACK FOOTER //
// ./src/components/Tabs/index.ts